import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  WebexInMeeting,
  WebexMeetingControlBar,
  WebexDataProvider
} from '@webex/components';

import styles from './styles.css';

const ActiveMeeting = ({setEscapedAuthentication,adapter, meetingId}) => {
  const controls = () => ['mute-audio', 'mute-video', 'share-screen', 'leave-meeting'];
  const tabIndexes = () => [0, 0, 0, 0];

  return (
    <WebexDataProvider adapter={adapter}>
      <div className={classNames(styles.callContainer, 'call-container', 'wxc-theme-light')}>
        <WebexInMeeting
          meetingID={meetingId}
          style={{flex: 1}}
          setEscapedAuthentication={setEscapedAuthentication}
        />
        <WebexMeetingControlBar
          className={styles.callControls}
          meetingID={meetingId}
          controls={controls}
          tabIndexes={tabIndexes}
        />
      </div>
    </WebexDataProvider>
  );
};

ActiveMeeting.propTypes = {
  adapter: PropTypes.object.isRequired,
  meetingId: PropTypes.string.isRequired
};

export default ActiveMeeting;
